"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var kb_http_service_1 = require("./kb-http.service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var store_1 = require("@ngrx/store");
var KbHttpOfflineService = /** @class */ (function (_super) {
    __extends(KbHttpOfflineService, _super);
    function KbHttpOfflineService(http, store, applicationPropertiesService) {
        return _super.call(this, http, store, applicationPropertiesService) || this;
    }
    KbHttpOfflineService.prototype.extractMetaCategories = function (responseData, categoryType) {
        return this.kbDeserializationHelper.extractCategories(responseData, categoryType, true);
    };
    KbHttpOfflineService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            store_1.Store,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], KbHttpOfflineService);
    return KbHttpOfflineService;
}(kb_http_service_1.KbHttpService));
exports.KbHttpOfflineService = KbHttpOfflineService;
//# sourceMappingURL=kb-http-offline.service.js.map